// FaceShapeCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Bentuk Wajah";
const DESCRIPTION = "Kalkulator untuk menentukan bentuk wajah berdasarkan pengukuran dan fitur.";
const KEYWORDS = "bentuk wajah, kalkulator, kecantikan, fitur wajah";
const OG_URL = "https://do-calculate.com/calculator/id/face-shape-calculator/";
function Example() {
  const [sex, setSex] = useState("");
  const [foreheadWidth, setForeheadWidth] = useState();
  const [cheeksWidth, setCheeksWidth] = useState();
  const [jawlineLength, setJawlineLength] = useState();
  const [faceLength, setFaceLength] = useState();
  const [features, setFeatures] = useState("");
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    const minForeheadWidth = 7.62;
    const minCheeksWidth = 7.62;
    const minJawlineLength = 7.62;
    const minFaceLength = 12.7;
    if (
      foreheadWidth < minForeheadWidth ||
      cheeksWidth < minCheeksWidth ||
      jawlineLength < minJawlineLength ||
      faceLength < minFaceLength
    ) {
      setError(
        `Nilai yang dimasukkan tidak valid. Harap pastikan untuk mengikuti batas minimum pengukuran yaitu:\n
            1- Lebar dahi minimum: ${minForeheadWidth} cm\n
            2- Lebar pipi minimum: ${minCheeksWidth} cm\n
            3- Panjang rahang minimum: ${minJawlineLength} cm\n
            4- Panjang wajah minimum: ${minFaceLength} cm`
      );
      return;
    }
    let faceShape = "Tidak Ditentukan";
    if (faceLength > cheeksWidth && foreheadWidth > jawlineLength) {
      faceShape = "Bentuk Wajah: Oval";
    } else if (faceLength > cheeksWidth && jawlineLength === foreheadWidth) {
      faceShape = "Bentuk Wajah: Persegi Panjang";
    } else if (
      faceLength === cheeksWidth &&
      foreheadWidth < cheeksWidth &&
      jawlineLength < cheeksWidth
    ) {
      faceShape = "Bentuk Wajah: Bulat";
    } else if (
      faceLength === cheeksWidth &&
      jawlineLength > cheeksWidth &&
      jawlineLength === foreheadWidth
    ) {
      faceShape = "Bentuk Wajah: Persegi";
    } else if (jawlineLength > cheeksWidth && cheeksWidth > foreheadWidth) {
      faceShape = "Bentuk Wajah: Segitiga";
    } else if (jawlineLength < cheeksWidth && foreheadWidth >= cheeksWidth) {
      faceShape = "Bentuk Wajah: Hati";
    } else if (
      jawlineLength < cheeksWidth &&
      foreheadWidth < cheeksWidth &&
      faceLength > foreheadWidth &&
      features === "Tajam"
    ) {
      faceShape = "Bentuk Wajah: Berlian";
    } else if (
      foreheadWidth === cheeksWidth &&
      faceLength === jawlineLength &&
      features === "Tajam"
    ) {
      faceShape = "Bentuk Wajah: Persegi";
    } else if (
      ((foreheadWidth === cheeksWidth) === faceLength) === jawlineLength &&
      (features === "Bulat" || "Sedang")
    ) {
      faceShape = "Bentuk Wajah: Persegi Panjang";
    } else if (
      foreheadWidth === cheeksWidth &&
      faceLength === jawlineLength &&
      (features === "Bulat" || "Sedang")
    ) {
      faceShape = "Bentuk Wajah: Segitiga";
    } else if (
      ((foreheadWidth === cheeksWidth) === faceLength) === jawlineLength &&
      features === "Tajam"
    ) {
      faceShape = "Bentuk Wajah: Persegi";
    }
    setResult(faceShape);
    setError("");
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Pernahkah Anda bertanya-tanya tentang bentuk wajah Anda? Apakah oval, persegi, hati, atau bentuk lainnya? Sekarang, Anda dapat mengetahuinya secara akurat menggunakan kalkulator cerdas kami untuk menentukan bentuk wajah. Cukup masukkan pengukuran dasar wajah Anda dan pilih deskripsi fitur Anda, dan Anda akan mendapatkan hasil yang akurat dalam hitungan detik.
                </p>
                <p>
                  Kalkulator kami menganalisis data yang Anda masukkan, seperti lebar dahi, lebar pipi, panjang rahang, panjang wajah, serta deskripsi fitur Anda (tajam, bulat, atau sedang). Dari informasi ini, kalkulator dapat menentukan bentuk geometris yang mendekati bentuk wajah Anda. Baik Anda tertarik untuk mengetahui bentuk wajah Anda karena rasa ingin tahu, atau untuk menentukan potongan rambut atau kacamata yang sesuai, kalkulator kami adalah alat yang sempurna untuk Anda.
                </p>
                <p>
                  Untuk menentukan bentuk wajah, Anda dapat memasukkan pengukuran yang diperlukan dan memilih deskripsi fitur.
                </p>
                <ul>
                  <li>
                    Masukkan jenis kelamin, lebar dahi, lebar pipi, panjang rahang, panjang wajah.
                  </li>
                  <li>Pilih satuan ukur (cm atau inci).</li>
                  <li>
                    Pilih bagaimana Anda menggambarkan fitur wajah Anda: tajam, bulat, atau sedang.
                  </li>
                </ul>
                <p>
                  Kalkulator ini dikembangkan berdasarkan studi analisis bentuk wajah.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group items-center">
                      <label className="form-label ms-2" htmlFor="sex">
                        Pilih Jenis Kelamin
                      </label>
                      <select
                        id="sex"
                        value={sex}
                        onChange={(e) => setSex(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">Pilih Jenis Kelamin</option>
                        <option value="Laki-laki">Laki-laki</option>
                        <option value="Perempuan">Perempuan</option>
                      </select>
                    </div>
                    <div
                      className="form-group"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <label
                        
                        style={{ marginBottom: "0.5rem" }}
                        htmlFor="foreheadWidth"
                      >
                        Lebar Dahi
                      </label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="foreheadWidth"
                          type="number"
                          value={foreheadWidth}
                          onChange={(e) => setForeheadWidth(e.target.value)}
                          placeholder="Masukkan lebar dahi"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                        <span className="input-group-text">cm</span>
                      </div>
                    </div>
                    <div
                      className="form-group"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <label
                        
                        style={{ marginBottom: "0.5rem" }}
                        htmlFor="cheeksWidth"
                      >
                        Lebar Pipi
                      </label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="cheeksWidth"
                          type="number"
                          value={cheeksWidth}
                          onChange={(e) => setCheeksWidth(e.target.value)}
                          placeholder="Masukkan lebar pipi"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                        <span className="input-group-text">cm</span>
                      </div>
                    </div>
                    <div
                      className="form-group"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <label
                        
                        style={{ marginBottom: "0.5rem" }}
                        htmlFor="jawlineLength"
                      >
                        Panjang Rahang
                      </label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="jawlineLength"
                          type="number"
                          value={jawlineLength}
                          onChange={(e) => setJawlineLength(e.target.value)}
                          placeholder="Masukkan panjang rahang"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                        <span className="input-group-text">cm</span>
                      </div>
                    </div>
                    <div
                      className="form-group"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <label
                        
                        htmlFor="faceLength"
                        style={{ marginBottom: "0.5rem" }}
                      >
                        Panjang Wajah
                      </label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="faceLength"
                          type="number"
                          value={faceLength}
                          onChange={(e) => setFaceLength(e.target.value)}
                          placeholder="Masukkan panjang wajah"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                        <span className="input-group-text">cm</span>
                      </div>
                    </div>
                    <div className="form-group" >
                      <label className="form-label ms-2" htmlFor="features">Deskripsikan Fitur Wajah Anda</label>
                      <select
                        id="features"
                        value={features}
                        onChange={(e) => setFeatures(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">Pilih Deskripsi Fitur</option>
                        <option value="Tajam">Tajam</option>
                        <option value="Bulat">Bulat</option>
                        <option value="Sedang">Sedang</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Error: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Hasil:</h4>
                      <p className="text-white">{result}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Lebih Lanjut tentang Bentuk Wajah</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Apa itu Bentuk Wajah?</h2>{" "}
                  </u>
                  <p>
                    Bentuk wajah dapat diklasifikasikan berdasarkan sejumlah kriteria seperti lebar dahi, lebar pipi, panjang rahang, dan panjang wajah. Semua faktor ini bersama dengan deskripsi fitur dapat membantu menentukan bentuk wajah.
                  </p>
                  <div className="p-3 mb-2 bg-info ">
                    Contoh: jika lebar dahi lebih besar dari lebar pipi dan panjang wajah lebih besar dari panjang rahang, dengan fitur yang tajam, bentuk wajah mungkin oval.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Bagaimana Cara Meningkatkan Penampilan Wajah Berdasarkan Bentuk?
                    </h2>{" "}
                  </u>
                  <p>
                    Mengetahui bentuk wajah Anda memungkinkan Anda memilih potongan rambut, kacamata, dan riasan yang paling sesuai dengan fitur Anda.
                  </p>
                  <ul>
                    <li>
                      Bentuk wajah oval cocok dengan hampir semua jenis potongan rambut.
                    </li>
                    <li>
                      Bentuk persegi dapat diuntungkan dengan potongan rambut yang menambah kelembutan pada sudut-sudutnya.
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Contoh: sudut yang lembut dapat membantu mengoreksi bentuk wajah persegi.
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Apa Perbedaan Antara Berbagai Bentuk Wajah?
                    </h2>{" "}
                  </u>
                  <p>
                    Bentuk wajah berbeda dalam proporsi antara lebar dahi, pipi, dan rahang, serta panjang wajah secara keseluruhan. Perbedaan ini dapat menciptakan tampilan yang unik untuk setiap individu.
                  </p>
                  <b>Contoh</b>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Jika Anda memiliki bentuk wajah segitiga, Anda mungkin ingin menyoroti aspek lain dari penampilan Anda untuk menyeimbangkan proporsi.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default Example;